module.exports = __webpack_public_path__ + "static/media/ZSCE_TP_CIDADES_TROCA.0ac56a4d.pdf";